'use client';

import { useResetSearch } from '@/hooks/useResetSearch';
import Link from 'next/link';
import { ReactNode } from 'react';

interface ResetLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
}

export function ResetLink({ href, children, className }: ResetLinkProps) {
  const { handleReset } = useResetSearch();

  return (
    <Link href={href} onClick={handleReset} className={className}>
      {children}
    </Link>
  );
}
